import { render } from "./RealEstate.vue?vue&type=template&id=5b91332e&scoped=true"
import script from "./RealEstate.vue?vue&type=script&lang=js"
export * from "./RealEstate.vue?vue&type=script&lang=js"

import "./RealEstate.vue?vue&type=style&index=0&id=5b91332e&scoped=true&lang=css"
import "./RealEstate.vue?vue&type=style&index=1&id=5b91332e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b91332e"]])

export default __exports__